/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Phases_EmbeddingInputs */



/**
* | output |
* | --- |
* | "Embedding files..." |
*
* @param {Upload_Phases_EmbeddingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upload_phases_embedding = /** @type {((inputs?: Upload_Phases_EmbeddingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Phases_EmbeddingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien werden eingebettet...")
	return /** @type {LocalizedString} */ ("Embedding files...")
});